<template>
    <p-sidebar
        v-if="show"
        v-model:visible="show"
        :show-close-icon="true"
        position="right"
        class="c-documents-popup"
    >
        <div class="dashboard__view-top">
            <div class="dashboard__view-reference">
                <strong>
                    <i18n-t keypath="myOrders.documents" />
                </strong>
            </div>
            <div class="dashboard__popup-close">
                <button
                    class="dashboard__popup-closeBtn"
                    type="button"
                    @click="() => (show = false)"
                >
                    <svg class="sprite-icon" width="18" height="18">
                        <use xlink:href="/img/sprite.svg#close"></use>
                    </svg>
                </button>
            </div>
        </div>

        <p-scrollpanel class="c-documents-popup--sidebar-items">
            <div
                v-if="orderCarDocuments?.documents"
                class="p-d-flex p-flex-column p-pb-5"
            >
                <div class="dashboard__view">
                    <div class="dashboard__view-top">
                        <div class="dashboard__view-reference">
                            <strong>
                                <i18n-t keypath="myOrders.orderReference" />
                                :
                            </strong>
                            {{ orderCarDocuments.order_reference }}
                        </div>
                        <div class="dashboard__view-date">
                            <strong>
                                <i18n-t keypath="myOrders.orderDate" />
                                :
                            </strong>
                            {{ formatDate(orderCarDocuments.order_date) }}
                        </div>
                        <div class="dashboard__view-id">
                            <strong>ID:</strong>
                            {{ orderCarDocuments.car.id }}
                        </div>
                        <div class="dashboard__view-vin">
                            <strong>VIN:</strong>
                            {{ orderCarDocuments.car.vin }}
                        </div>
                    </div>
                    <div class="dashboard__view-center">
                        <div class="dashboard__carInfo-item">
                            <div
                                class="dashboard__carInfo-img"
                                :style="{
                                    backgroundSize: 'cover',
                                }"
                                v-app-fast-gallery="{
                                    images: orderCarDocuments.car.images,
                                }"
                            ></div>
                            <div class="dashboard__carInfo-info">
                                <h5 class="dashboard__carInfo-name">
                                    {{ orderCarDocuments.car.title }}
                                </h5>
                                <p class="dashboard__carInfo-desc">
                                    {{ orderCarDocuments.car.description }}
                                </p>
                                <div class="dashboard__carInfo-price">
                                    <span class="dashboard__bold">
                                        <app-format-currency
                                            :value="orderCarDocuments.car.total"
                                            :currency="orderCarDocuments.car.currency"
                                        ></app-format-currency>
                                    </span>
                                    <span class="dashboard__normal">
                                        *
                                        <i18n-t keypath="myOrders.exclusiveVat" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dashboard__view-bottom">
                        <div class="documents">
                            <p class="documents__title">
                                <i18n-t keypath="myOrders.documents" />
                            </p>
                            <ul class="documents__items">
                                <li
                                    v-for="doc in orderCarDocuments.documents"
                                    v-bind:key="doc.name"
                                    class="documents__item"
                                >
                                    <div class="documents__item-left">
                                        <svg
                                            class="sprite-icon documents__icon"
                                            width="16"
                                            height="16"
                                        >
                                            <use
                                                :xlink:href="`/img/sprite.svg#${doc.file_type}`"
                                            ></use>
                                        </svg>
                                        <div class="documents__name">
                                            <span>{{ doc.name }}</span>
                                        </div>
                                    </div>
                                    <div class="documents__item-right">
                                        <a class="documents__view" :href="doc.url">
                                            <svg
                                                class="sprite-icon documents__icon"
                                                width="15"
                                                height="10"
                                            >
                                                <use
                                                    xlink:href="/img/sprite.svg#eye-2"
                                                ></use>
                                            </svg>
                                        </a>
                                        <a
                                            class="documents__download"
                                            :href="doc.url"
                                            download
                                        >
                                            <svg
                                                class="sprite-icon documents__icon"
                                                width="12"
                                                height="12"
                                            >
                                                <use
                                                    xlink:href="/img/sprite.svg#download"
                                                ></use>
                                            </svg>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </p-scrollpanel>
    </p-sidebar>
</template>

<script lang="ts">
import { DocumentsPopup } from "@/dashboard/my-orders/popup/documents-popup/documents-popup.ts";
export default DocumentsPopup;
</script>

<style lang="scss">
.c-documents-popup .p-sidebar-header {
    display: none;
}

.c-documents-popup {
    min-width: 344px;
    width: 25vw;
    padding: 0;

    .p-sidebar-content {
        padding: 0 !important;
    }
}

.c-documents-popup--sidebar-title-container {
    height: 62px;
    background: rgba(228, 234, 240, 0.2);
    letter-spacing: 0em;
    font-family: var(--font-family);
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #283747;
}

.c-documents-popup--sidebar-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.c-documents-popup--sidebar-item-photos {
    height: 42px;
    min-width: 62.5px;
    border-radius: 4px;
    background-size: cover;
}

.c-documents-popup--sidebar-items {
    height: calc(100vh - 47px);

    .p-scrollpanel-content {
        padding: 0;
    }

    .p-scrollpanel-bar {
        opacity: 1;
        transition: background-color 0.3s;
        width: 4px;
        border-radius: 3px;
        background: rgba(24, 29, 39, 0.4) !important;
        left: calc(100% - 7px) !important;
    }

    .p-scrollpanel-bar:hover {
        background: rgba(24, 29, 39, 0.8) !important;
    }
}

.c-documents-popup--sidebar-item {
}

.c-documents-popup--sidebar-item-content-price {
    color: #283747;
    font-family: var(--font-family);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0em;
}

.c-documents-popup--sidebar-item-content-description {
    font-family: var(--font-family);
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    color: #627690;
}

.c-documents-popup--sidebar-item-content-link {
    font-family: var(--font-family);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    color: var(--color-primary);
}

.c-documents-popup--sidebar-item-content-features {
    .features__list-label {
        margin-bottom: 8px;
    }
}

.c-documents-popup--sidebar-footer {
    height: 60px;
}
</style>
